import React from 'react';
import './WidgetItemListWrap.scss';

const WidgetItemListWrap = (props) => {
  const { title, children } = props;

  return (
    <div className="widget-item-list-wrap">
      <div className="title">{title}</div>
      {children}
    </div>
  );
};

export default WidgetItemListWrap;
